<template>
  <v-autocomplete
    v-model="localValue"
    hide-details
    :hint="`${localValue}`"
    label="Select Athlete Name"
    :items="getAthletes"
    item-value="athleteId"
    :item-text="athleteLongName"
    dense
    :rules="requiredRule"
    outlined
    sort
    clearable
  >
  </v-autocomplete>
</template>

<script>
import { mapGetters } from "vuex";
import { validation } from "../../mixins/validationMixin";
//import { mounted } from "vue-social-sharing";

export default {
  props: {
    parentValue: {
      type: Number,
      default: () => 0,
      required: true,
    },
    mode: {
      type: String,
      default: () => "",
      required: false,
    },
  },
  mixins: [validation],
  model: {
    prop: "parentValue",
    event: "parentValueChange",
  },
  data() {
    return {
      athleteId: null,
    };
  },
  computed: {
    ...mapGetters([
      "loading",
      "athleteList",
      "resultsList",
      "athleteOfficialResults",
    ]),
    getAthletes() {
      const { athleteList, resultsList, athleteOfficialResults, mode } = this;

      const isValidNode = (node) =>
        node &&
        typeof node.athleteId !== "undefined" &&
        typeof node.firstName === "string" &&
        typeof node.lastName === "string";

      const buildAthleteList = (athleteIds) => {
        return athleteIds
          .map(function (athleteId) {
            const edge = athleteList.edges.find(function (i) {
              return (
                i && i.node && Number(i.node.athleteId) === Number(athleteId)
              );
            });

            if (!edge || !isValidNode(edge.node)) return null;

            return {
              athleteId: athleteId,
              firstName: edge.node.firstName,
              lastName: edge.node.lastName,
              birthDate: edge.node.birthDate || "Unknown",
            };
          })
          .filter(Boolean); // Remove invalid or null results
      };

      if (!athleteList || !Array.isArray(athleteList.edges)) return [];

      if (mode === "ATH") {
        const ids = Array.from(
          new Set(
            athleteList.edges
              .map(function (e) {
                return e && e.node && e.node.athleteId;
              })
              .filter(function (id) {
                return typeof id !== "undefined";
              })
          )
        );
        return buildAthleteList(ids);
      }

      if (mode !== "PERF" && resultsList.length > 0) {
        const ids = Array.from(
          new Set(
            resultsList
              .map(function (r) {
                return r.athleteId;
              })
              .filter(function (id) {
                return typeof id !== "undefined";
              })
          )
        );
        return buildAthleteList(ids);
      }

      if (mode === "PERF" && athleteOfficialResults.length > 0) {
        const ids = Array.from(
          new Set(
            athleteOfficialResults
              .map(function (r) {
                return r && r.node && r.node.athleteId;
              })
              .filter(function (id) {
                return typeof id !== "undefined";
              })
          )
        );
        return buildAthleteList(ids);
      }

      return [];
    },

    localValue: {
      get: function () {
        return this.parentValue;
      },
      set: function (value) {
        this.$emit("parentValueChange", value);
      },
    },
  },
  created() {
    this.handleGetAthleteList();
    // if (!(Object.entries(this.$route.query).length === 0)) {
    //   const { athleteId } = this.$route.query;
    //   //assign to current instance variables
    //   this.athleteId = athleteId;
    // }
  },
  mounted() {
    console.log(this.athleteList);
  },
  methods: {
    athleteLongName: (item) =>
      // item.athleteId +
      // " " +
      item.firstName + " " + item.lastName + " (" + item.birthDate + ")",
    handleGetAthleteList() {
      //reach out of Vuex store, fire action that gets athletes
      this.$store.dispatch("allAthlete", {
        clubId: this.$route.params.club,
      });
    },

    // Define the method that emits data to the parent as the first parameter to `$emit()`.
    // This is referenced in the <template> call in the parent. The second parameter is the payload.
    // emitToParent (eevnt) {

    //   this.$emit('childToParent', this.childMessage)
    // }
  },
  // watch: {
  //   athleteId: function() {
  //     this.$emit("change-athlete", this.athleteId);
  //   }
  // }
};
</script>
